import { render } from "./PaginationGuide.vue?vue&type=template&id=28ba1c49"
import script from "./PaginationGuide.vue?vue&type=script&lang=js"
export * from "./PaginationGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__